// src/utils/stringUtils.js

// Capitalize the first letter of a string
export function capitalizeFirstLetter(string) {
    if (!string) return ''; // Handle empty or undefined strings
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

  export function removeUnderScore  (key){
    if (!key) return ''; 
    return key
        .replace(/_/g, ' ')               // Replace underscores with spaces
        .replace(/\w\S*/g, (w) =>         // Capitalize each word
            w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
        );
};
  // Capitalize the first letter of every word in a sentence
  export function capitalizeWords(string) {
    if (!string) return '';
    return string
      .split(' ')
      .map(word => capitalizeFirstLetter(word))
      .join(' ');
  }
  
  export function isJsonObject(obj) {
    return obj !== null && typeof obj === 'object' && !Array.isArray(obj);
  }

  export function getUserNameFromId(userId){
    try{
    const userMasterData = JSON.parse(localStorage.getItem("userMasterData"));
    const user = userMasterData.filter((item)=>item.id===userId)[0];
    return user.firstName;
    }catch(ex){
    return userId;
    }

    
}

export function formatDate(isoString) {
  const date = new Date(isoString);
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  
  let hours = date.getHours();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
}